const tabs = document.querySelectorAll('.hoox-results__tab');
tabs.forEach(tab => {
    tab.addEventListener('click', () => {
        console.log(tab);
        setActive(tab);
    })
});


const showPanels = (tab) => {
    tab.addEventListener('click', () => {
        let tabIndex = tab.getAttribute('data-tab');
        let tabsBox = document.querySelectorAll('.hoox-results__tab-box');

        tabsBox.forEach(panel => {
        console.log(panel);

            const panelIndex = panel.getAttribute('data-tab-box');
            if(panelIndex === tabIndex) {
                setActive(panel);
            } 
        })
    })
}

const setActive = function (el) {
    [...el.parentElement.children].forEach(function (sib) {
        sib.classList.remove('active');
    });
    el.classList.add('active');
};

tabs.forEach(tab => {
    showPanels(tab);
});